import { useEffect, useRef } from 'react';

declare const window: Window &
  typeof globalThis & {
    Trustpilot?: {
      loadFromElement: (el: HTMLElement, state: boolean) => void;
    };
  };

export const useTrustpilotRef = () => {
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // without this the widget won't load when we navigate from one page containing the
    // script to another.
    if (widgetRef.current && window.Trustpilot) {
      window.Trustpilot.loadFromElement(widgetRef.current, true);
    }
  }, []);

  return widgetRef;
};
